/**
 * Time unit associated with protection term events.
 * tag: 40196
 * @readonly
 * @enum {string} (String)
 */
export enum ProtectionTermEventUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
}
